<template>
  <b-modal
      id="add-break-code"
      ref="add-break-code"
      size="sm-size"
      modal-class="break-modal"
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{label.get('add_new_break_type')}}
      </h2>
    </div>
    <div class="content-wrapper hasScroll">
      <perfect-scrollbar>
        <div class="form-container">
          <div class="input-wrapper no-mb">
            <div class="name-holder">
              <span class="heading-title">{{ label.get('name') }}</span>
            </div>
            <div class="type-holder">
              <span class="heading-title">{{ label.get('type') }}</span>
            </div>
          </div>
          <div
              v-for="(item, idx) in breakCodes"
              :key="idx"
              class="input-wrapper"
          >
            <div class="name-holder">
              <input
                  v-model="item.name"
                  ref="job"
                  type="text"
                  :placeholder="label.get('add_break_type_name_placeholder')"
                  class="atto-input"
              >
            </div>
            <div class="type-holder">
              <select-dropdown-component
                  :value="item.type"
                  placeholder="Select method"
                  :options="breakTypes"
                  :index="idx"
                  @onOptionSelected="onPaidRulesChanged"
              />
            </div>

          </div>
          <button
              class="add-new-btn"
              @click="addMoreBreakCodes"
          >
            <i class="atto atto-add-more" />
            {{label.get('add_break_types')}}
          </button>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
            class="atto-btn cancel"
            @click="close"
        >
          {{label.get('cancel')}}
        </button>
        <button
            class="atto-btn submit add-jobs-btn"
            :disabled="disabledSaveButton"
            @click="addBreakCodes"
        >
          {{label.get('add_type')}}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import BreakPreferencesService from "../services/BreakPreferencesService";
  import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
  export default {
    name: "AddBreakCodeComponent",
    components: {
      SelectDropdownComponent
    },
    data() {
      return {
        disabledSaveButton: false,
        breakTypes: this.getBreakTypes(),
        breakCodes: [
          {
            id: null,
            name: '',
            type: 1
          }
        ]
      }
    },
    mounted() {
      document.body.appendChild(this.$el);
      this.$refs['add-break-code'].show();
    },
    methods: {
      getBreakTypes(){
        return BreakPreferencesService.getBreakTypes(this.label);
      },
      onPaidRulesChanged(option, idx){
        this.breakCodes[idx].type = option.value;
      },
      close() {
        this.$root.$emit('hideAddBreakCode');
      },
      addMoreBreakCodes() {
        let emptyFields = false;
        this.breakCodes.forEach((item) => {
          if (item.name.trim() === '') {
            emptyFields = true;
          }
        });
        if (!emptyFields) {
          this.breakCodes.push({
            id: null,
            name: '',
            type: 1
          });
        }

      },
      addBreakCodes() {
        const data = this.breakCodes.filter((item) => {
          return item.name.trim() !== '';
        });
        if (data.length === 0) {
          return;
        }
        this.disabledSaveButton = true;
        BreakPreferencesService.saveBreakCodes({ breakCodes: data }).then((result) => {
          this.$root.$emit('hideAddBreakCode', result.data);
        }).catch((error) => {
          this.disabledSaveButton = false;
        });
      }
    }
  }
</script>

<style lang="scss">
  .modal .modal-content .modal-body .content-wrapper {
    padding: 8px 40px 24px 40px;
  }
  .modal-content .content-wrapper > .ps{
    padding-right: 40px !important;
  }
  .modal .modal-head h2.modal-title{
    text-transform: capitalize !important;
  }

  .break-modal{
    .modal-sm-size{
      width: 496px;
      max-width: 496px;
    }
    .form-container{
      .input-wrapper{
        width: 100%;
        display: flex;

        .heading-title{
          color: #999999;
          font: $roboto-medium 0.6875rem/0.8125rem $roboto-font;
          margin: 0 0 4px 0;
          padding: 0;
          text-transform: uppercase;
        }

        .type-holder{
          width: 160px;
        }
        .name-holder{
          width: 240px;
          margin-right: 16px;
        }
        &.no-mb {
          margin-bottom: 0;
        }
      }
    }
  }

</style>